import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { getRGBA } from '@cobliteam/base-components/src/styles/helpers';

export const card = css`
  border: 1px solid ${colors.gray.light};
  border-radius: 5px;

  height: 150px;

  &:hover {
    background-color: ${getRGBA(colors.accessory._5, 0.08)};
    border-color: ${colors.primary.default};
    cursor: pointer;
  }
`;

export const textColor = css`
  color: ${colors.gray.dark};
`;
